"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const modal_dialog_selectors_1 = require("./modal-dialog-selectors");
const jQueryStatic = require("jquery");
require("./modal-dialog.scss");
/*
DESCRIPTION OF MODAL DIALOG

ModalDialog and its derivatives are expected to operate on modal-dialog.html.

For (legacy) architectural reasons and for performance reasons that arise from
the application's architecture, the HTML file (modal-dialog.html)
takes its own way to the browser. (For the same reasons, there exists only a
single common HTML template for all kinds of dialog implementations.)

That means: Even though it is located next to all other source files,
it is never required nor imported (by Webpack).

Instead, it is loaded through an HtmlTemplateManager instance (C# code;
HtmlTemplateManager.cs).

*/
class ModalDialog {
    constructor(_config = {}) {
        this._config = _config;
        this._clickCallback = (clickEvent) => {
            // send the click event to the current dialog
            this.handleButtonClickEvent(clickEvent, this.resultCallback);
        };
        this._keyUpCallback = (keyUpEvent) => {
            // send the keyup event to the current dialog
            this.handleDialogKeyup(keyUpEvent, this.resultCallback);
        };
    }
    // jQuery
    get jQuery() {
        return this._config.jQuery || jQueryStatic;
    }
    // CSS Selectors
    get rootSelector() {
        return this._config.rootSelector || modal_dialog_selectors_1.RootSelector;
    }
    // derivatives are expected to feature distinct bodies
    get footerSelector() {
        const selector = this._config.footerSelector || modal_dialog_selectors_1.FooterSelector;
        return `${this.rootSelector} ${selector}`;
    }
    get buttonSelector() {
        const selector = this._config.buttonSelector || modal_dialog_selectors_1.ButtonSelector;
        return `${this.rootSelector} ${selector}`;
    }
    // Helpers
    setVisibilityBySelector(selector, visible) {
        if (visible) {
            this.jQuery(selector).show();
        }
        else {
            this.jQuery(selector).hide();
        }
    }
    setTextBySelector(selector, text) {
        this.jQuery(selector).text(text);
    }
    // Visibility
    setDialogVisibility(visible) {
        // show the dialog (CAUTION "modal" is a bootstrap method)
        const root = this.jQuery(this.rootSelector);
        if (visible) {
            return new Promise((resolve) => {
                root.one('shown.bs.modal', () => {
                    resolve();
                });
                root.modal("show");
            });
        }
        else {
            return new Promise((resolve) => {
                root.one('hidden.bs.modal', () => {
                    resolve();
                });
                root.modal("hide");
            });
        }
    }
    show(resultCallback) {
        this._config.dialogManager.putDialog({
            object: this,
            resultCallback: resultCallback
        });
    }
    activate() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.setDialogVisibility(true);
            this.jQuery(this.rootSelector).addClass(this.getCssClass());
            this.setContentVisibility(true);
            this.changeInputEventSubscription(true);
        });
    }
    hide() {
        this.setDialogVisibility(false); // = tell bootstrap to hide the modal
        if (document.activeElement instanceof HTMLElement) { // Remove focus from input so the keyboard is removed on iOS devices.
            document.activeElement.blur();
        }
    }
    destroy() {
        this.jQuery(this.rootSelector).removeClass(this.getCssClass());
        this.changeInputEventSubscription(false);
        this.setContentVisibility(false); // CAUTION  never call this before
        // the hide animation is done (unless you know what you are doing)
        // the ModalDialogManager will call "destroy" for you on "hidden.bs.modal"
        console.debug(`${this.toString()} destroyed`);
    }
    handleDialogShown(shownEvent) { }
    handleDialogKeyup(keyupEvent, resultCallback) {
        if (keyupEvent.which === 13) { // Return key
            this.handleButtonClick(this.okCloseButton, resultCallback);
            return;
        }
        if (keyupEvent.which === 27) { // Escape key
            this.handleButtonClick(this.cancelCloseButton, resultCallback);
            return;
        }
    }
    handleButtonClickEvent(clickEvent, resultCallback) {
        const buttonMatcher = this._config.buttonMatcher || this.getButtonMatcher();
        const buttonIdentifier = buttonMatcher(clickEvent);
        this.handleButtonClick(buttonIdentifier, resultCallback);
    }
    handleInputFocus(focusEvent) { }
    // subscribe/unsubscribe is important because the "keyup" event listens
    // to keyups on the whole document => thus it should only stay subscribed
    // as long as the dialog + its backdrop cover the entire screen
    changeInputEventSubscription(subscribe) {
        const method = subscribe ? "on" : "off";
        if (subscribe) {
            // ensure we do not subscribe twice
            this.changeInputEventSubscription(false); // unsubscribe
        }
        this.jQuery(this.buttonSelector)[method]("click", this._clickCallback);
        this.jQuery(document)[method]("keyup", this._keyUpCallback);
        console.debug("changed input click+event subscription", subscribe);
    }
    get resultCallback() {
        const dialog = this._config.dialogManager.peekDialog();
        return dialog.resultCallback;
    }
}
exports.default = ModalDialog;
